import { Container, Img } from './TransitionButtonStyles';
import right from '@/assets/right_black.svg';

interface TransitionButtonProps {
  direction?: 'left' | 'right';
  variant?: 'small' | 'big';
  onClick?: () => void;
}

const TransitionButton = ({
  direction = 'right',
  variant = 'big',
  onClick,
}: TransitionButtonProps) => {
  let width, height;

  if (variant === 'small') {
    width = '32px';
    height = '32px';
  } else {
    width = '48px';
    height = '48px';
  }

  return (
    <Container onClick={onClick} width={width} height={height}>
      <Img
        src={right}
        alt="arrow"
        isRotate={direction === 'left'}
        width={variant === 'small' ? '16px' : '24px'}
      />
    </Container>
  );
};

export default TransitionButton;
